import { useState } from "react";
import { http } from "@/lib/api";
import { toast } from "sonner";
import { Modal } from "./AdminShared";

export default function PlanModal({ plan, onClose, onSaved }) {
  const isNew = !plan.id;
  const [form, setForm] = useState(plan);
  const [saving, setSaving] = useState(false);
  const [perksText, setPerksText] = useState((plan.perks || []).join("\n"));

  const submit = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const body = { ...form, perks: perksText.split("\n").filter(Boolean), price: parseFloat(form.price), sort_order: parseInt(form.sort_order || 1) };
      delete body.id; delete body.created_at;
      if (isNew) await http.post("/admin/subscription-plans", body);
      else await http.put(`/admin/subscription-plans/${plan.id}`, body);
      toast.success("Saved."); onSaved();
    } catch { toast.error("Save failed."); }
    finally { setSaving(false); }
  };

  return (
    <Modal title={isNew ? "New Plan" : `Edit · ${form.name}`} onClose={onClose}>
      <form onSubmit={submit} className="space-y-3" data-testid="plan-form">
        <input required placeholder="Plan Name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="stc-input" data-testid="plan-name-input"/>
        <textarea placeholder="Description" rows={2} value={form.description} onChange={e => setForm({...form, description: e.target.value})} className="stc-input font-body"/>
        <div className="grid grid-cols-3 gap-3">
          <select value={form.frequency} onChange={e => setForm({...form, frequency: e.target.value})} className="stc-input">
            <option value="weekly">Weekly</option><option value="monthly">Monthly</option><option value="yearly">Yearly</option>
          </select>
          <input required type="number" step="0.01" placeholder="Price USD" value={form.price} onChange={e => setForm({...form, price: e.target.value})} className="stc-input"/>
          <input type="number" placeholder="Sort order" value={form.sort_order} onChange={e => setForm({...form, sort_order: e.target.value})} className="stc-input"/>
        </div>
        <div>
          <div className="font-ui text-[10px] tracking-[0.32em] text-[#C9A055] mb-1">Perks (one per line)</div>
          <textarea rows={6} value={perksText} onChange={e => setPerksText(e.target.value)} className="stc-input font-body"/>
        </div>
        <div className="flex gap-4 text-sm">
          <label className="flex items-center gap-2 text-[#F4F1EA]"><input type="checkbox" className="accent-[#C9A055]" checked={form.active} onChange={e => setForm({...form, active: e.target.checked})}/> Active</label>
          <label className="flex items-center gap-2 text-[#F4F1EA]"><input type="checkbox" className="accent-[#C9A055]" checked={form.featured} onChange={e => setForm({...form, featured: e.target.checked})}/> Featured / Most Popular</label>
        </div>
        <div className="flex justify-end gap-3 pt-3 border-t border-white/10">
          <button type="button" onClick={onClose} className="btn-outline">Cancel</button>
          <button disabled={saving} className="btn-gold" data-testid="plan-save-btn">{saving ? "Saving…" : "Save"}</button>
        </div>
      </form>
    </Modal>
  );
}
